const YearlyKMValues = [
    '500',
    '1000',
    '2000',
    '3000',
    '5000',
    '8000',
    '15000',
    '20000',
    '30000',
    '50000',
    '60000',
    '80000',
    '100000',
];

export default YearlyKMValues;
